import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';

import { faArrowsRepeat } from '@fortawesome/pro-duotone-svg-icons';

import { useNewRiskMutate } from '@repo/api/risk/risks';

import { Route as ClaimsHome } from '~pages/_claims/claims';
import { Route as NewRoute } from '~pages/_risks/risk.$riskId/(nopr)/create.$page';
import { Route as RisksHome } from '~pages/_risks/risks';
import { Page } from './-components/Page';

export const Route = createFileRoute('/_risks')({
	component: function Risks() {
		const { mutate: mutateNewRisk, isPending: newRiskLoading } =
			useNewRiskMutate();

		const navigate = useNavigate();

		return (
			<Page
				home={{ link: RisksHome, label: 'Risks' }}
				adminActions={[
					{
						name: 'Switch to Claims',
						icon: faArrowsRepeat,
						route: { to: ClaimsHome.to },
						permission: 'claim',
					},
				]}
				createButton={{
					permission: 'home.risk.create',
					label: 'Create New Risk',
					action: () => {
						mutateNewRisk(undefined, {
							onSuccess: (data) => {
								void navigate({
									to: NewRoute.to,
									params: { riskId: `${data.riskId}`, page: 'insured' },
								});
							},
						});
					},
					loading: newRiskLoading,
				}}
				help={[
					{
						label: 'Manual Intervention',
						name: 'ManualIntervention',
						message:
							'Need help? Watch this quick video guide to walk you through the manual intervention process',
					},
				]}
			>
				<Outlet />
			</Page>
		);
	},
});
